<template>
  <div>
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="employees"
        :rules="ruleValidate"
        class="form"
        label-width="100px"
    >
      <el-tabs v-model="activeName">
        <el-tab-pane label="基本信息" name="first">
          <el-row>
            <el-col :span="8">
              <el-form-item label="编号">
                <el-input
                    v-model="employees.employeeNO"
                    disabled
                    placeholder="请输入"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="姓名">
                <el-input
                    v-model="employees.employeeName"
                    disabled
                    placeholder="请输入"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="性别">
                <el-select
                    v-model="employees.gender"
                    disabled
                    clearable
                    placeholder="请选择"
                >
                  <el-option
                      v-for="item in genders"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="部门">
                <el-input
                    v-model="employees.departmentName"
                    disabled
                    placeholder="请输入"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="职位">
                <el-input
                    v-model="employees.postName"
                    disabled
                    placeholder="请输入"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="电话">
                <el-input
                    v-model="employees.telephone"
                    placeholder="请输入电话"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="手机号">
                <el-input
                    v-model="employees.mobile"
                    placeholder="请输入手机号"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="邮箱">
                <el-input v-model="employees.email" placeholder="请输入邮箱"/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="生日">
                <el-date-picker
                    v-model="employees.birthday"
                    align="right"
                    type="date"
                    style="width: 100%"
                    placeholder="请选择日期"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="邮编">
                <el-input
                    v-model="employees.postCode"
                    placeholder="请输入邮编"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="地址">
                <el-input
                    v-model="employees.address"
                    placeholder="请输入地址"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="备注">
                <el-input
                    v-model="employees.note"
                    type="textarea"
                    autosize
                    placeholder="请输入备注"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="text-align: right">
            <el-button
                v-if="saveAuth"
                :loading="submitLoading"
                type="primary"
                @click="handleSubmit"
            >
              保存
            </el-button>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="修改密码" name="second">
          <el-row>
            <el-col :span="8">
              <el-form-item label="原密码" prop="oldPassword">
                <el-input
                    v-model="employees.oldPassword"
                    placeholder="请输入原密码"
                    type="password"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="新密码" prop="newPassword">
                <el-input
                    v-model="employees.newPassword"
                    placeholder="请输入新密码"
                    type="password"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="确认密码" prop="confirmPd">
                <el-input
                    v-model="employees.confirmPd"
                    placeholder="请输入确认密码"
                    type="password"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="text-align: right">
            <el-button
                :loading="submitLoading"
                type="primary"
                @click="handleSubmits"
            >
              保存
            </el-button>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </el-form>
  </div>
</template>

<script>
  import constant from "../../../util/constant";
  import regular from "@/util/regular";

  export default {
    name: "ProfilesList",
    components: {},
    data() {
      return {
        saveAuth: this.$auth(264),
        constant,
        genders: constant.toSelect(constant.gender),
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        activeName: "first",
        employees: {
          employeeID: "",
          employeeNO: "",
          employeeName: "",
          gender: "",
          departmentID: "",
          departmentName: "",
          postID: "",
          postName: "",
          birthday: "",
          telephone: "",
          mobile: "",
          address: "",
          email: "",
          postCode: "",
          note: "",
          id: 90,
          oldPassword: "",
          newPassword: "",
          confirmPd: "",
        },
        ruleValidate: {
          oldPassword: { required: true, message: "请输入原密码", trigger: "blur" },
          newPassword: {
            required: true,
            pattern: regular.password,
            trigger: "blur",
            message: "6~20位,不能为纯数字或者纯字母",
          },
          confirmPd: { required: true, message: "请输入确认密码", trigger: "blur" },
        },
      };
    },
    mounted() {
      this.getMessage();
    },
    methods: {
      getMessage() {
        this.$http.get("basic", "employees/employeeInfo").then((resp) => {
          console.log(resp);
          if (resp.success) {
            this.employees = resp.data;
          }
        });
      },
      handleSubmit() {
        this.submitLoading = true;
        this.$http
          .put("basic", "employees", this.employees)
          .then((resp) => {
            if (resp.success) {
              this.$emit("save-success");
              this.$message.success("保存成功");
            }
            this.submitLoading = false;
            this.dialogVisible = false;
          })
          .catch(() => {
            this.submitLoading = false;
          });
      },
      handleSubmits() {
        console.log(this.employees.oldPassword);
        if (this.employees.oldPassword == null || this.employees.newPassword== null || this.employees.confirmPd== null) {
          return this.$message.error("密码不能为空");
        }
        if (this.employees.oldPassword === this.employees.newPassword) {
          return this.$message.error("您的新密码与原密码一致，无需更改");
        } else if (this.employees.newPassword !== this.employees.confirmPd) {
          return this.$message.error("请统一新密码");
        } else {
          this.$refs.form.validate((valid) => {
            if (valid) {
              this.submitLoading = true;
              this.$http
                .post("basic", "system/user/updatePassword", this.employees)
                .then((resp) => {
                  if (resp.success) {
                    this.$emit("save-success");
                    this.$message.success("保存成功");
                  }
                  this.submitLoading = false;
                  this.dialogVisible = false;
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            }
          });
        }
      },
    },
  };
</script>

<style scoped></style>
